/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/ClientSide/javascript.js to edit this template
 */


import { useState, useEffect }
    from "react";
import { useParams, useLocation }
    from 'react-router-dom';

import { Container, Row, Col, Tab, Nav }
    from 'react-bootstrap';
import { library }
    from '@fortawesome/fontawesome-svg-core';
import { fas }
    from '@fortawesome/free-solid-svg-icons';
import { fab }
    from '@fortawesome/free-brands-svg-icons';
import { far }
    from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon }
    from '@fortawesome/react-fontawesome';

library.add(fas, fab, far);
function Cancellation() {

    return (
        <div>
            <Row><h2>Cancellation, Returns & Refunds</h2></Row>
            <br />
            <Row>
                <p>
                    <b>Eligible Returns:</b><br />
                    To qualify for a return, your item must be unused, in the same condition as when you received it, and in its original packaging.<br />
                    <br />
                    <b>Non-Returnable Items:</b><br />
                    Please note, the following items cannot be returned:<br />
                    • Perishable goods like food, flowers, newspapers, and magazines<br />
                    • Intimate or sanitary products<br />
                    • Hazardous materials, flammable liquids, or gases<br />
                    • Gift cards<br />
                    • Certain health and personal care items<br />
                    <br />
                    <b>Proof of Purchase:</b><br />
                    Returns must be accompanied by a receipt or proof of purchase. Do not send items back to the manufacturer.<br />
                    <br />
                    <b>Partial Refunds</b><br />
                    Partial refunds may be issued if:<br />
                    • The item isn’t in its original condition, is damaged, or missing parts (unless due to our error)<br />
                    • The return is made more than 30 days after delivery<br />
                    <br />
                    <b>Refund Process</b><br />
                    Once we receive and inspect your return, you’ll get an email confirming receipt and whether your refund is approved or denied. Approved refunds will be processed back to your original payment method within a few days.<br />
                    <b>Haven’t received your refund yet?</b><br />
                    • Double-check your bank account<br />
                    • Contact your credit card company (refunds can take time to post)<br />
                    • Contact your bank for any processing delays<br />
                    If you still don’t see your refund, email us at gracesupermarketgood@yahoo.com.<br />
                    <br />
                    <b>Sale Items</b><br />
                    Only regular-priced items are eligible for refunds. Sale items cannot be refunded.<br />
                    <br />
                    <b>Exchanges</b><br />
                    Need to exchange a defective or damaged item? No problem! Email us at gracesupermarketgood@yahoo.com for assistance.<br />
                    <br />
                    <b>Gifts</b><br />
                    • If your item was a gift sent directly to you, you’ll receive a gift credit for the return value.<br />
                    • If the gift was shipped to the giver, the refund will be sent to them, and they will be notified.<br />
                    <br />
                    <b>Shipping Returns</b><br />
                    Please send returns to:<br />
                    Grace Super Market<br />
                    You’re responsible for return shipping costs, which are non-refundable. If you get a refund, shipping fees will be deducted from the amount.<br />
                    For returns over ₹1000, we recommend using a trackable shipping service or purchasing shipping insurance. Unfortunately, we cannot guarantee receipt of your returned item without tracking.<br />
                </p>
            </Row>
        </div>

    );
}

export default Cancellation;